import axios from '@/plugins/axios'
import { Module } from 'vuex'
import router from '../router'

export interface KeywordBlacklist {
    username: string
    token: string
}

const keywordBlacklistModule: Module<any, any> = {
    actions: {
        async GetBlacklist({ commit }) {
            const response = {
                data: [
                    {
                        id: 0,
                        keyword: 'Headache',
                        addedBy: {
                            name: 'Brad Dickinson',
                            profile: '/images/profile-img/img-01.jpg',
                        },
                        action: 'Block Post',
                        notify: [
                            {
                                id: 0,
                                profile: '/images/profile-img/img-01.jpg',
                            },
                            {
                                id: 1,
                                profile: '/images/profile-img/img-02.jpg',
                            },
                            {
                                id: 2,
                                profile: '/images/profile-img/img-03.jpg',
                            },
                        ],
                        flagCount: 0,
                    },
                    {
                        id: 0,
                        keyword: 'Bleeding',
                        addedBy: {
                            name: 'Luke Parker',
                            profile: '/images/profile-img/img-02.jpg',
                        },
                        action: 'Flag Comment',
                        notify: 'All admins',
                        flagCount: 17,
                    },
                ],

                changeLog: [
                    {
                        id: 1,
                        member: {
                            id: 1,
                            name: 'Kathryn Murphy',
                            profile: '/images/profile-img/img-01.jpg',
                        },
                        changeType: 'approved',
                        dateChanged: '2021-10-01',
                        parameter: 'Domain URL',
                        previousValue: 'www.anotherwebsite.com',
                        ipAddress: '176.994.234',
                    },
                    {
                        id: 2,
                        member: {
                            id: 1,
                            name: 'Tim Bell',
                            profile: '/images/profile-img/img-02.jpg',
                        },
                        changeType: 'approved',
                        dateChanged: '2021-10-01',
                        parameter: 'Domain URL',
                        previousValue: 'www.anotherwebsite.com',
                        ipAddress: '176.994.234',
                    },
                ],

                totalRows: 2,
            }

            return response
        },

        async GetChangelog({ commit }) {
            const response = {
                data: [
                    {
                        id: 1,
                        member: {
                            id: 1,
                            name: 'Kathryn Murphy',
                            profile: '/images/profile-img/img-01.jpg',
                        },
                        changeType: 'approved',
                        dateChanged: '2021-10-01',
                        parameter: 'Domain URL',
                        previousValue: 'www.anotherwebsite.com',
                        ipAddress: '176.994.234',
                    },
                    {
                        id: 2,
                        member: {
                            id: 1,
                            name: 'Tim Bell',
                            profile: '/images/profile-img/img-02.jpg',
                        },
                        changeType: 'approved',
                        dateChanged: '2021-10-01',
                        parameter: 'Domain URL',
                        previousValue: 'www.anotherwebsite.com',
                        ipAddress: '176.994.234',
                    },
                ],

                totalRows: 2,
            }

            return response
        },
    },
}

export default keywordBlacklistModule
